import { render } from "./BaseDetail.vue?vue&type=template&id=744acf96&scoped=true"
import script from "./BaseDetail.vue?vue&type=script&lang=js"
export * from "./BaseDetail.vue?vue&type=script&lang=js"

import "./BaseDetail.vue?vue&type=style&index=0&id=744acf96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744acf96"]])

export default __exports__